import { Tooltip, TooltipContent, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { useRef, useState } from 'react';
import { IdentifiedProfileResponse } from '../../api/DTO/IdentifiedProfileResponse';
import { ShortlistedProfile } from '../../api/DTO/ShortlistedProfile';
import AiSearchCompanyDetail from '../AiSearchCompanyDetail/AiSearchCompanyDetail';
import CompanyLogo from '../CompanyLogo/CompanyLogo';

const createLinkedInUrl = (companyId: string | null) => {
    if (!companyId) return null;
    return `https://www.linkedin.com/company/${companyId}`;
};

const CompanyCell = ({ profile }: IdentifiedProfileResponse | ShortlistedProfile) => {
    const anchorRef = useRef<HTMLParagraphElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);
    const [open, setOpen] = useState(false);

    const handleMouseEnter = () => {
        if (!anchorRef.current) return;
        setIsOverflowing(anchorRef.current.scrollWidth > anchorRef.current.clientWidth);
    };

    const openCompanyDetail = () => profile.currentCompanyDomain && setOpen(true);
    const closeCompanyDetail = () => setOpen(false);

    return (
        <>
            <div
                data-cy="companyCell"
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    e.preventDefault();
                    if (e.key === 'Enter' || e.key === ' ') {
                        openCompanyDetail();
                    }
                }}
                className={`flex max-h-8 w-full items-center gap-2.5 ${
                    profile.currentCompanyDomain ? 'cursor-pointer hover:underline' : ''
                }`}
                onClick={openCompanyDetail}
            >
                <CompanyLogo
                    companyDomain={profile.currentCompanyDomain}
                    companyName={profile.currentCompanyName}
                    size="32px"
                />
                <Tooltip>
                    <TooltipTrigger asChild>
                        <p
                            ref={anchorRef}
                            className="text-foreground overflow-hidden text-sm text-ellipsis whitespace-nowrap"
                            style={{ textDecoration: 'inherit' }}
                            onMouseEnter={handleMouseEnter}
                        >
                            {profile.currentCompanyName}
                        </p>
                    </TooltipTrigger>
                    {isOverflowing && <TooltipContent>{profile.currentCompanyName}</TooltipContent>}
                </Tooltip>
            </div>
            {profile.currentCompanyName && (
                <AiSearchCompanyDetail
                    open={open}
                    companyName={profile.currentCompanyName}
                    companyDomain={profile.currentCompanyDomain}
                    companyLinkedInUrl={createLinkedInUrl(profile.currentCompanyCompanyId)}
                    onClose={closeCompanyDetail}
                    anchorEl={anchorRef.current}
                />
            )}
        </>
    );
};

export default CompanyCell;
